import React, { memo, useState } from 'react';
import Search from "../Components/Common/Search";
// import FAQVideosList from "../Components/FAQ/FAQVideosList";
import Roles from "../Config/Roles";
import { Col, Container, Row } from "react-bootstrap";
import TrainningVideosList from '../Components/Traininng/TrainningVideosList';


function Training() {

    /**
     * The video data that we want to feed to FAQ Page. Each video data has its headline,
     * the URL where the video is hosted and respective visibility permissions.
     * @type {[{visible: string[], name: string, URL: string}, {visible: (string)[], name: string, URL: string},
     * {visible: string[], name: string, URL: string}, {visible: (string)[], name: string, URL: string},
     * {visible: (string)[], name: string, URL: string}, null, null, null]}
     */
    const videoData = [
        // {
        //     name: 'Test',
        //     URL: "https://vimeo.com/1023913955?share=copy",
        //     visible: [Roles.SUPER_ADMIN, Roles.ADMIN, Roles.ANALYST]
        // },
        // {
        //     name: 'Test',
        //     URL: "https://vimeo.com/1023913955?share=copy",
        //     visible: [Roles.SUPER_ADMIN, Roles.ADMIN, Roles.ANALYST]
        // },
        // {
        //     name: 'Test',
        //     URL: "https://vimeo.com/1023913955?share=copy",
        //     visible: [Roles.SUPER_ADMIN, Roles.ADMIN, Roles.ANALYST]
        // },
        // {
        //     name: 'Test',
        //     URL: "https://vimeo.com/1023913955?share=copy",
        //     visible: [Roles.SUPER_ADMIN, Roles.ADMIN, Roles.ANALYST]
        // },
        // {
        //     name: 'Test',
        //     URL: "https://vimeo.com/1023913955?share=copy",
        //     visible: [Roles.SUPER_ADMIN, Roles.ADMIN, Roles.ANALYST]
        // },
        // {
        //     name: 'Test',
        //     URL: "https://vimeo.com/1023913955?share=copy",
        //     visible: [Roles.SUPER_ADMIN, Roles.ADMIN, Roles.ANALYST]
        // },
        // {
        //     name: 'Test',
        //     URL: "https://vimeo.com/1023913955?share=copy",
        //     visible: [Roles.SUPER_ADMIN, Roles.ADMIN, Roles.ANALYST]
        // },
        // {
        //     name: 'Test',
        //     URL: "https://vimeo.com/1023913955?share=copy",
        //     visible: [Roles.SUPER_ADMIN, Roles.ADMIN, Roles.ANALYST]
        // },
        // {
        //     name: 'Test',
        //     URL: "https://vimeo.com/1023913955?share=copy",
        //     visible: [Roles.SUPER_ADMIN, Roles.ADMIN, Roles.ANALYST]
        // },
        // {
        //     name: 'Test',
        //     URL: "https://vimeo.com/1023913955?share=copy",
        //     visible: [Roles.SUPER_ADMIN, Roles.ADMIN, Roles.ANALYST]
        // },
        // {
        //     name: 'Test',
        //     URL: "https://vimeo.com/1023913955?share=copy",
        //     visible: [Roles.SUPER_ADMIN, Roles.ADMIN, Roles.ANALYST]
        // },
        {
            name: 'Umgang mit Vorbemerkungen - Beispiel Kabelzugliste und elektrische Anschlussarbeiten',
            URL: "https://vimeo.com/1022792765?share=copy#t=0",
            visible: [Roles.SUPER_ADMIN, Roles.ADMIN, Roles.ANALYST]
        },
        {
            name: 'Umgang mit Vorbemerkungen - Beispiel Bautagesberichte',
            URL: "https://vimeo.com/1022792728?share=copy#t=0",
            visible: [Roles.SUPER_ADMIN, Roles.ADMIN, Roles.ANALYST, Roles.CALCULATOR]
        },
        {
            name: 'Umgang mit Vorbemerkungen - Beispiel Aufmaßdetaillierung',
            URL: "https://vimeo.com/1022792684?share=copy#t=0",
            visible: [Roles.SUPER_ADMIN, Roles.ADMIN, Roles.ANALYST]
        },
        {
            name: 'Pflicht zur Bieterfrage existiert wirklich?',
            URL: "https://vimeo.com/1022792646?share=copy#t=0",
            visible: [Roles.ADMIN, Roles.ANALYST, Roles.SUPER_ADMIN, Roles.CALCULATOR]
        },
        {
            name: 'Bieterfragen stellen bis zum Tag der Submission',
            URL: "https://vimeo.com/1022792607?share=copy#t=0",
            visible: [Roles.SUPER_ADMIN, Roles.ADMIN, Roles.ANALYST, Roles.CALCULATOR]
        },
        {
            name: 'Umgang mit Vorbemerkungen - Beispiel Ortsbesichtigung und Jour-Fix-Teilnahme',
            URL: "https://vimeo.com/1022782866?share=copy#t=0",
            visible: [Roles.ADMIN, Roles.SUPER_ADMIN, Roles.ANALYST, Roles.CALCULATOR]
        },
        {
            name: 'Rahmenbedingungen zur einhaltung der auschreibungsregeln für den AG',
            URL: "https://vimeo.com/1022782770",
            visible: [Roles.SUPER_ADMIN, Roles.ADMIN, Roles.ANALYST]
        },
        {
            name: 'Unterschied Koordination zu Kooperation',
            URL: "https://vimeo.com/1022782975",
            visible: [Roles.SUPER_ADMIN, Roles.ADMIN, Roles.ANALYST]
        },
        {
            name: 'Unterschied gewerblicher Auftraggeber zu öffentlicher Auftraggeber',
            URL: "https://vimeo.com/1022782957",
            visible: [Roles.SUPER_ADMIN, Roles.ADMIN, Roles.ANALYST]
        },
        {
            name: 'Mischkalkulation verboten',
            URL: "https://vimeo.com/1022782677",
            visible: [Roles.SUPER_ADMIN, Roles.ADMIN, Roles.ANALYST]
        },
        {
            name: 'Umgang mit Vorbemerkungen - Beispiel Lagerräume',
            URL: "https://vimeo.com/1022782824",
            visible: [Roles.SUPER_ADMIN, Roles.ADMIN, Roles.ANALYST]
        },
        {
            name: 'Auschreibungsregel 1',
            URL: "https://vimeo.com/1022782459",
            visible: [Roles.SUPER_ADMIN, Roles.ADMIN, Roles.ANALYST]
        },
        {
            name: 'Auschreibungsregel 2',
            URL: "https://vimeo.com/1022782501",
            visible: [Roles.SUPER_ADMIN, Roles.ADMIN, Roles.ANALYST]
        },
        {
            name: 'Auschreibungsregel 3',
            URL: "https://vimeo.com/1022782516",
            visible: [Roles.SUPER_ADMIN, Roles.ADMIN, Roles.ANALYST]
        },
        {
            name: 'Auschreibungsregel 4',
            URL: "https://vimeo.com/1022782547",
            visible: [Roles.SUPER_ADMIN, Roles.ADMIN, Roles.ANALYST]
        },
        {
            name: 'Auschreibungsregel 5',
            URL: "https://vimeo.com/1022782581",
            visible: [Roles.SUPER_ADMIN, Roles.ADMIN, Roles.ANALYST]
        },
        {
            name: 'Auschreibungsregel 6',
            URL: "https://vimeo.com/1022782617",
            visible: [Roles.SUPER_ADMIN, Roles.ADMIN, Roles.ANALYST]
        },
        {
            name: 'Auschreibungsregel 7',
            URL: "https://vimeo.com/1022782651",
            visible: [Roles.SUPER_ADMIN, Roles.ADMIN, Roles.ANALYST]
        },
        {
            name: 'Umgang mit Vorbemerkungen - Beispiel Schützen bis zur Abnahme',
            URL: "https://vimeo.com/1022782438",
            visible: [Roles.SUPER_ADMIN, Roles.ADMIN, Roles.ANALYST]
        },
    ];

    /**
     * searchData is used to capture the user input for search functionality.
     */
    const [searchData, setSearchData] = useState('');

    /**
     * handleSearchChange updates the searchData value for each user input i.e., captured by event.
     * @param event
     */
    const handleSearchChange = (event) => {
        setSearchData(event.target.value);
    }

    /**
     * filteredVideos maintains the list of videos matching the searchData
     * @type {({visible: string[], name: string, URL: string}|null)[]}
     */
    const filteredVideos = videoData.filter(video => (
        video.name.toLowerCase().includes(searchData.toLowerCase())
    ));

    return (
        <div style={{ color: 'white', minHeight:'100vh' }}>

            <br />

            <div className="handwai-dark" style={borerStyle}>
                <br />

                <Container fluid>
                    <Row>
                        <Col sm={2} className="handwai-text-label-normal">Suchen</Col>
                        <Col sm={10} style={searchStyle}>
                            <Search
                                placeholder="Suchen"
                                handleChange={handleSearchChange}
                            />
                        </Col>
                    </Row>

                    <br />
                    <TrainningVideosList videoData={filteredVideos} />
                </Container>
            </div>

        </div>
    )
}

const searchStyle = {
    marginLeft: -80
}

const borerStyle = {
    margin: 20,
    padding: 20,
    paddingBottom: 50,
    color: "white",
    minHeight:'100vh'
}

export default memo(Training);
